<template>
    <div id="response-reply-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="response-reply-title" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="response-reply-title">Reply</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <div class="d-flex">
                        <div class="font-weight-bold pr-2">Reply To:</div>
                        <div class="text-truncate pr-2" :title="destination.name">{{ destination.name }}</div>
                        <div v-if="this.method === TransmissionMethod.FAX">
                            <telephone-input v-if="destination.edit" class="form-control form-control-sm" placeholder="Fax Number" v-model="destination.number" @blur.native="onChange()" @keyup.native.enter="onChange()" v-focus></telephone-input>
                            <span v-else @click="destination.edit = true;">                                        
                                {{ destination.number | telephone }}
                                <a href="javascript:void(0)" title="Edit Fax Number"><i class="fas fa-pencil-alt fa-xs"></i></a>
                            </span>
                        </div>
                        <div v-else>
                            <input v-if="destination.edit" class="form-control form-control-sm" placeholder="Email Address" v-model="destination.email" @blur.native="onChange()" @keyup.native.enter="onChange()" v-focus>
                            <span v-else @click="destination.edit = true;">                                        
                                {{ destination.email }}
                                <a href="javascript:void(0)" title="Edit Email Address"><i class="fas fa-pencil-alt fa-xs"></i></a>
                            </span>                            
                        </div>
                    </div>
                    <div v-if="document" class="mt-2">
                        <span class="font-weight-bold">Replying To Document:</span>
                        <div class="text-truncate pl-3" :title="document.document_type.name + ' - ' + document.description">
                            {{ document.document_type.name }} - {{ document.description }}
                        </div>                                            
                    </div>
                </div>
                <div class="modal-body border-top pt-1">                      
                    <div class="d-flex mt-3">
                        <div class="dropdown">
                            <button class="btn btn-sm btn-primary dropdown-toggle" title="Add Attachment" data-toggle="dropdown">
                                <i class="fas fa-paperclip fa-lg"></i>
                            </button>
                            <div class="dropdown-menu float-above">
                                <a class="dropdown-item" href="javascript:void(0)" @click="showClaimDocuments()">Browse Claim Documents...</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="upload()">Browse Computer...</a>                                        
                            </div>
                        </div>
                        <div class="instructions text-muted px-2">
                            Click the paperclip button to add attachments from available claim documents or browse for a file on your computer. 
                        </div>                             
                    </div>                       
                    <div :class="['mt-1 pl-1', { 'border-top': attachments.length }]">
                        <div v-for="attachment in attachments" class="d-flex flex-row" :key="'submission-attachment-' + attachment.id">
                            <div class="pr-1">                                 
                                <a href="javascript:void(0)" class="remove-button" title="Remove Attachment" @click="removeAttachment(attachment.id)">
                                    <i class="fas fa-minus-circle fa-xs"></i>
                                </a>
                            </div>                                
                            <div class="text-truncate" :title="attachment.document_type.name + ' - ' + attachment.description">
                                {{ attachment.document_type.name + ' - ' + attachment.description }}
                            </div>
                        </div>
                    </div>
                </div>                  
                <div class="modal-footer">
                    <button class="btn btn-primary" :disabled="disabled" @click="reply()">Reply</button> 
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>    
                </div>                
            </div>
        </div>
    </div>    
</template>

<script>
import { DocumentType, TransmissionMethod } from '../../constants.js';

export default {
    data() {
        return {
            TransmissionMethod: TransmissionMethod,

            method: null,
            document: null,
            destination: {
                number: null,
                email: null,
                edit: false
            },
            attachments: [],
            options: []
        }
    },
    computed: {
        disabled: function () {
            return !(this.method === TransmissionMethod.FAX && this.destination.number && this.attachments.length ||
                     this.method === TransmissionMethod.EMAIL && this.destination.email && this.attachments.length);
        }
    },
    methods: {
        show: function (method, document) {
            this.method = method;
            this.document = document;
            this.destination = {
                name: null,
                number: null,
                email: null,
                edit: false
            };

            axios.get('/ajax/responses/' + this.document.id + '/reply/' + this.method)
            .then(response => {
                this.destination.name = response.data.destination_name;
                this.destination.number = response.data.destination_fax;
                this.destination.email = response.data.destination_email;
                this.options = response.data.options;
            })
            .catch(error => {
                console.log(error.response.data.message);
            });
            $('#response-reply-modal').modal('show');
        },
        onChange: function () {
            this.destination.edit = false;
            this.$emit('update');            
        },
        upload: function () {
            $('#response-reply-modal').modal('hide');
            eventHub.$emit('show-attachment-upload', this.options, DocumentType.LWC_FORM_1010A_RESPONSE , this.addAttachment, 'reply-modal-visible', this.document.id);
        },        
        showClaimDocuments: function () {
            $('#response-reply-modal').modal('hide');

            // pass in any attached documents so they can be pre-selected in the attachments modal
            let preselected = this.attachments.map(e => e.id);
            eventHub.$emit('show-add-attachments', this.document.document_type_id, preselected, this.addAttachments, 'reply-modal-visible', this.document.id);
        },
        addAttachment: function (document) {
            this.attachments.push(document);
        },    
        addAttachments: function (selectedDocuments) {
            this.attachments = selectedDocuments;
        },
        removeAttachment: function (id) {
            this.attachments = this.attachments.filter(e => e.id != id);
        },                
        reply: function () {

            let dest = (this.method === TransmissionMethod.EMAIL) ? this.destination.email : this.destination.number;
            axios.post('/ajax/responses/' + this.document.id + '/reply/' + this.method, {
                destination: {
                    name: this.destination.name,
                    destination: dest
                },
                attachments: this.attachments          
            })
            .then(response => {
                $('#response-reply-modal').modal('hide');
            })
            .catch(error => {
                console.log(error.response.data.message);
                $('#response-reply-modal').modal('hide');
            });
        }
    },
    created() {
        eventHub.$on('show-reply-modal', this.show);
        eventHub.$on('reply-modal-visible', function () { 
            $('#response-reply-modal').modal('show'); 
        });        
    },
    beforeDestroy() {
        eventHub.$off('show-reply-modal');
        eventHub.$off('reply-modal-visible');
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus();
            }
        }
    } 
}
</script>

<style scoped>
    .remove-button {
        position: relative;
        top: -3px;
    }

    .instructions {
        line-height: 1.2em;
        font-size: .90em;
        font-style: italic;
    }
</style>